import * as S from "../Style/Page/Hat.style.js";

const LeftImg =
  `${process.env.REACT_APP_ASSET_BASE || ""}` +
  "/static/media/hatsbusiness.a5002a4bbf089c7feae8.png";

const HatPageTopLine = (props) => {
  return (
    <S.PageTopLine>
      <div className="page-top-line-left">
        <img src={LeftImg} alt="" />
      </div>

      <div className="page-top-line-title">
        <div className="kor">{props.titleko}</div>
        <div className="eng">{props.titleeng}</div>
      </div>

      <div className="page-top-line-right"></div>
    </S.PageTopLine>
  );
};

export default HatPageTopLine;